import { create } from "zustand"

interface PrivacyPolicyUpdateModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

const usePrivacyPolicyUpdateModalStore = create<PrivacyPolicyUpdateModalStore>(
  (set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  })
)

export default usePrivacyPolicyUpdateModalStore
